import api from "./api";

const VehicleService = {
    listVehicles: () => api.get("/api/vehicles/"),
    getVehicle: (id) => api.get(`/api/vehicles/${id}/`),

    listIssues: (params = {}) => api.get("/api/vehicle-issues/", { params }),
    createIssue: (data) => api.post("/api/vehicle-issues/", data),
    updateIssue: (id, data) => api.patch(`/api/vehicle-issues/${id}/`, data),
    deleteIssue: (id) => api.delete(`/api/vehicle-issues/${id}/`),

    listServices: () => api.get("/api/vehicle-service/"),
    createService: (data) => api.post("/api/vehicle-service/", data),
    updateService: (id, data) => api.patch(`/api/vehicle-service/${id}/`, data),
    deleteService: (id) => api.delete(`/api/vehicle-service/${id}/`),

    listCleanings: () => api.get("/api/vehicle-cleaning/"),
    createCleaning: (data) => api.post("/api/vehicle-cleaning/", data),
    updateCleaning: (id, data) => api.patch(`/api/vehicle-cleaning/${id}/`, data),
    deleteCleaning: (id) => api.delete(`/api/vehicle-cleaning/${id}/`),

    listInspections: (params = {}) => api.get("/api/vehicle-inspections/", { params }),
    createInspection: (data) => api.post("/api/vehicle-inspections/", data),
    updateInspection: (id, data) => api.patch(`/api/vehicle-inspections/${id}/`, data),
    deleteInspection: (id) => api.delete(`/api/vehicle-inspections/${id}/`),

    getInsurance: () => api.get("/api/fleet-insurance/"),
    updateInsurance: (data) => api.patch("/api/fleet-insurance/", data),
};

export default VehicleService;
